import useMainStore from '@/composables/use-main-store';
import { usePrivilegesStore } from '@/composables/use-privileges-store';
import { REQUIRED_PRIVILEGES } from '@/constants/required-privileges';
import REQUIRED_ROLES from '@/constants/required-roles';
import { AsaPrivilege } from '@/enums/api/attribute-store-adapter/asa-privilege';
import { CustomFeature } from '@/enums/custom-feature';
import Role from '@/enums/role';
import { FeatureFlagsService } from '@/services/feature-flags-service';
import { RoleProtectedFeature } from '@/types/feature-names';

const useFeatureAccessValidator = () => {
    const usePrivileges: boolean = FeatureFlagsService.isFeatureEnabled(CustomFeature.USE_ASA_PRIVILEGES);

    const { privileges } = usePrivilegesStore();
    const { attributeStoreData } = useMainStore();

    const validateTargetPrivileges = <T = AsaPrivilege | Role>(requiredPrivileges: T[], userPrivileges: T[]): boolean => {
        if (!requiredPrivileges.length) {
            return true;
        }

        return requiredPrivileges.some((privilege: T): boolean => userPrivileges.includes(privilege));
    };

    const validateAccess = (feature: RoleProtectedFeature): boolean => {
        if (usePrivileges) {
            return !!privileges.value && validateTargetPrivileges(REQUIRED_PRIVILEGES[feature], privileges.value);
        }

        return !!attributeStoreData.value && validateTargetPrivileges(REQUIRED_ROLES[feature], attributeStoreData.value?.role);
    };

    return {
        validateAccess
    };
};

export { useFeatureAccessValidator };
